export default __webpack_public_path__ + "static/media/logo-vw-comerciales.7b4ddda3.svg";